import { RouteComponentProps } from "react-router-dom";
import { RouteOnboardingRequirementDetailsContent } from "./RouteOnboardingRequirementDetailsContent";
import { WSPage } from "@wingspanhq/fe-component-library";
import { queriesRequirements } from "@query";
import { WSQueries } from "../../../../../query/WSQuery";

export const RouteOnboardingRequirementDetails: React.FC<
  RouteComponentProps<{
    requirementId: string;
  }>
> = ({
  match: {
    params: { requirementId }
  }
}) => {
  const queryRequirement = queriesRequirements.getPayeeRequirement.useQuery({
    requirementId
  });

  return (
    <WSPage>
      <WSQueries
        queries={{
          queryRequirement
        }}
      >
        {({ queryRequirementData }) => {
          return (
            <RouteOnboardingRequirementDetailsContent
              requirement={queryRequirementData}
            />
          );
        }}
      </WSQueries>
    </WSPage>
  );
};
